module.exports = __webpack_public_path__ + "img/background1.c4feef2f.png";